module.exports = __webpack_public_path__ + "static/colourmomentsblue-ba1d8bf192ea87ce576e91e9b235d08e.jpeg";